import "./App.css";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import DeleteAccount from "./delete_account";
import DeleteAccountSuccess from "./delete_account_success";
import TermsOfService from "./terms_of_service";
import PrivacyPolicy from "./privacy_policy";
import FeedbackForm from "./feedback_form";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/feedbackform" element={<FeedbackForm />} />
        <Route
          path="/termsofservice"
          element={<TermsOfService appName="Star!" />}
        />
        <Route
          path="/privacypolicy"
          element={<PrivacyPolicy appName="Star!" />}
        />
        <Route path="/deleteaccount" element={<DeleteAccount />} />
        <Route
          path="/deleteaccountsuccess"
          element={<DeleteAccountSuccess />}
        />
      </Routes>
    </Router>
  );
}

export default App;
